import { format } from 'date-fns';
import { it } from 'date-fns/locale';

export type CourseMetaForCertificate = {
  ecm?: boolean | number | null;
  provider?: string | null;
};

/** Riga sotto la data: provider come da DB; niente doppio "Corso ECM" se il provider cita già ECM. */
export function buildCertificateMetaLine(
  course: CourseMetaForCertificate
): string {
  const providerTrimmed = (course.provider ?? '').trim();
  const metaParts: string[] = [];
  const providerAlreadyMentionsEcm = /\becm\b/i.test(providerTrimmed);
  if (Boolean(course.ecm) && !providerAlreadyMentionsEcm) {
    metaParts.push('Corso ECM');
  }
  if (providerTrimmed) {
    metaParts.push(providerTrimmed);
  }
  return metaParts.join(' · ');
}

/** Data certificato solo calendario (nessuna ora sul foglio). */
export function formatCertificatePassedDate(iso: string): string {
  const dateOnly = iso.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    return format(new Date(iso), 'd MMMM yyyy', { locale: it });
  }
  return format(new Date(`${dateOnly}T12:00:00`), 'd MMMM yyyy', {
    locale: it,
  });
}

/** Data in formato gg/mm/aaaa (certificati ECM / attestazioni). */
export function formatCertificateDateDdMmYyyy(iso: string): string {
  const dateOnly = iso.slice(0, 10);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(dateOnly)
    ? new Date(`${dateOnly}T12:00:00`)
    : new Date(iso);
  return format(d, 'dd/MM/yyyy', { locale: it });
}

export type ItalianDoctorHonorific = {
  article: 'il' | 'la';
  honorific: 'Dott.' | 'Dott.ssa';
};

/**
 * Sceglie articolo e forma "Dott." / "Dott.ssa" dal titolo di cortesia del profilo (euristica).
 */
export function resolveItalianDoctorHonorific(
  title: string | null | undefined
): ItalianDoctorHonorific {
  const t = (title ?? '').toLowerCase();
  if (
    /\b(dott\.?\s*ssa|dottoressa|sig\.?\s*ra|signora|dr\.?\s*ssa)\b/.test(t)
  ) {
    return { article: 'la', honorific: 'Dott.ssa' };
  }
  return { article: 'il', honorific: 'Dott.' };
}
